import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PromocionesService } from '../../services/promociones.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { LfsaBotonsGridComponent } from 'src/app/shared/components/lfsa-botons-grid/lfsa-botons-grid.component';

@Component({
  selector: 'app-promocion-oficinas',
  templateUrl: './promocion-oficinas.component.html',
  styleUrls: ['./promocion-oficinas.component.css']
})
export class PromocionOficinasComponent implements OnInit {

  gridApi: any;
  gridColumnApi: any;
  columnDefsCondOficinaVenta = [];
  frameworkComponents: any;
  rowDataCondOficinaVenta: any[] = [];
  verFormularioAgregarCondOficinaVenta = false;

  idPromo: string;

  get idOficinas() {
    return this.rowDataCondOficinaVenta.map((item) => item.id_oficina_venta);
  }

  constructor(
    private readonly route: ActivatedRoute,
    private readonly promocionesService: PromocionesService,
    private readonly _util: UtilsService
  ) {
    this.gridComponent();
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const id = params['id'] as string
      if (id) {
        this.idPromo = id;
        this.cargarCondOficinaVenta(id);
      }
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  gridComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
      iconButtonRenderer: LfsaBotonsGridComponent
    };

    this.columnDefsCondOficinaVenta = [
      {
        headerName: 'Oficina Venta',
        field: 'id_oficina_venta',
        sortable: true,
        filter: true
      },
      {
        headerName: 'Descripción',
        field: 'name_oficina_venta',
        sortable: true,
        filter: true
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 40,
        cellStyle: {
          padding: 0
        },
        cellRendererParams: {
          onClick: this.eliminarCondOficinaVenta.bind(this),
          label: 'Eliminar',
          colorBoton: 'btn btn-danger btn-block',
        },
      },
    ];
  }

  nuevoCondOficinaVenta() {
    this.verFormularioAgregarCondOficinaVenta = true;
  }

  back() {
    this.verFormularioAgregarCondOficinaVenta = false;
  }

  cargarCondOficinaVenta(id_promo) {
    this.promocionesService.cargarCondOficinaVenta(id_promo.trim()).subscribe(
      (resp) => {
        if (resp) {
          this.rowDataCondOficinaVenta = resp;
        } else {
          this.rowDataCondOficinaVenta = [];
        }
      },
      (error) => {
        this.rowDataCondOficinaVenta = [];
      }
    );
  }

  eliminarCondOficinaVenta({ rowData }) {
    this._util
      .confirmarSincronoPromesa({
        title: 'Eliminar',
        action: 'Eliminar',
        funcion: this.promocionesService.borrarCondOficinaVenta(rowData),
      })
      .then((res: any) => {
        this.cargarCondOficinaVenta(this.idPromo);
      });
  }

  guardarCondOficinaVenta(payload: any) {
    this._util
      .confirmarSincronoPromesa({
        title: '¿Esta seguro que desea procesar el siguiente formulario?',
        action: 'Nuevo',
        funcion: this.promocionesService.crearCondOficinaVenta(payload),
      })
      .then((res: any) => {
        this.cargarCondOficinaVenta(this.idPromo);
        this.verFormularioAgregarCondOficinaVenta = false;
      });
  }

}
